import { GET_OBJECTIVES, GET_OBJECTIVE, UPDATE_OBJECTIVES, DELETE_OBJECTIVES, GET_RELATED_OBJECTIVES } from '../constants/action-types';
import { deleteObjectives } from '../actions/ObjectiveActions';

// INITIALIZE STATE
const initialState = {
    objectives: {},
    objective: {},
    relatedObjectives: {},
};

// REDUCER
export const ObjectivesReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_OBJECTIVES: {
            const incomingObjectives = action.payload;
            const objectives = {};

            incomingObjectives.forEach((objective) => {
                objectives[objective.id] = objective;
            });

            return {
                ...state,
                objectives: objectives
            }
        }
        case GET_OBJECTIVE: {
            return {
                ...state,
                objective: action.payload
            }
        }
        case DELETE_OBJECTIVES: {
            let newObjectives = Object.assign({}, state.objectives);
            let deletedObjectives = action.payload;
            
            deletedObjectives.forEach((deletedObjective) => {
                delete newObjectives[deletedObjective.id];
            });

            return {
                ...state,
                objectives: newObjectives
            }
        }
        case GET_RELATED_OBJECTIVES: {
            return {
                ...state,
                relatedObjectives: action.payload
            }
        }
        case UPDATE_OBJECTIVES: {
            let newObjectives = Object.assign({}, state.objectives);
            let objectives = action.payload;

            objectives.forEach((objective) => {
                newObjectives[objective.id] = objective
            })

            let objective = {};
            if (objectives.length == 1) {
                objective = objectives[0];
            }

            return {
                ...state,
                objectives: newObjectives,
                objective
            }
        }
        default:
            return state;
    }
};